import React from 'react';

class ModalCondo extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {

    }
    componentWillUnmount() {

    }
    handleSubmit(){
        this.props.callBack();
    }

    modalClose() {
        this.props.shouldModalClose(false);

    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >Remove Estate</h4>
                    </div>

                    <div className="modal-body" >
                        Estate information will be removed permanently. Are you sure?
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default btn-danger" onClick={this.handleSubmit}>Delete</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default ModalCondo;


// WEBPACK FOOTER //
// ./app/setComponents/condoSetComponents/modalCondo.js